import { render, staticRenderFns } from "./AddEditTask.vue?vue&type=template&id=bac14902"
import script from "./AddEditTask.vue?vue&type=script&lang=js"
export * from "./AddEditTask.vue?vue&type=script&lang=js"
import style0 from "./AddEditTask.vue?vue&type=style&index=0&id=bac14902&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports